// constants/subCategoryConstants.js
export const SUBCATEGORY_LIST_REQUEST = 'SUBCATEGORY_LIST_REQUEST';
export const SUBCATEGORY_LIST_SUCCESS = 'SUBCATEGORY_LIST_SUCCESS';
export const SUBCATEGORY_LIST_FAIL = 'SUBCATEGORY_LIST_FAIL';
